import { StyleSheet } from 'react-native';
import React, { useState } from 'react';
import { FONT_ENUM } from '../../../types/global/fonts.types';
import { ColorScheme, theme } from '../../../constants/theme';
import { Box, FormControl, FormLabel, Typography } from '@mui/material';
import { useThemeContext } from '../../../hook/useThemeManager';
import { DiscoveryFilter, FilterItem } from '../../../data/filters/discovery.data';

interface IFilterBlock {
    data: DiscoveryFilter;
    category: string;
    onChange?: ({ address, coord }: { address: string; coord: string[] }) => void;
    onFilterPressed?: () => void;
    open?: boolean;
    onFilterSelect?: (filterItem: FilterItem, categoryId: number) => void;
    disableLine?: boolean;
    defaultValue?: string;
    selectedValue?: string;
    openMap: boolean;
    setOpenMap: () => void;
}

const MobileLocationSeletor: React.FC<IFilterBlock> = ({
    data,
    category,
    onChange,
    onFilterPressed,
    open,
    onFilterSelect,
    disableLine,
    selectedValue,
    openMap,
    setOpenMap,
}) => {
    const { themeStyle } = useThemeContext();
    const styles = dynamicStyles(themeStyle);
    const [value] = useState<any>(selectedValue);

    return (
        <>
            <FormControl style={styles.dropdown}>
                <FormLabel
                    style={styles.titleScreen}
                    sx={{
                        border: 'none',
                        marginBottom: '5px',
                    }}>
                    {data.categoryName}
                </FormLabel>
                <Box sx={{ width: '100%' }}>
                    <Typography
                        onClick={setOpenMap}
                        style={{
                            fontFamily: FONT_ENUM.REGULAR_HEADER,
                            color: theme[themeStyle].switchGreen,
                            fontSize: 16,
                            cursor: 'pointer',
                        }}>
                        {value}
                    </Typography>
                </Box>
                {!disableLine && (
                    <hr style={{ width: '100%', borderBottom: `1px solid ${theme[themeStyle].gray_text}` }} />
                )}
            </FormControl>
        </>
    );
};

export { MobileLocationSeletor };

const dynamicStyles = (colorScheme: ColorScheme) =>
    StyleSheet.create({
        mainButton: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 100,
            height: '40px',
            paddingBottom: 10,
            paddingTop: 10,
            paddingLeft: 5,
            paddingRight: 5,
            textTransform: 'none',
        },
        screenTitle: {
            fontSize: 12,
            fontWeight: '500',
            fontFamily: FONT_ENUM.MAIN_MEDIUM,
            color: theme[colorScheme].form_label,
        },
        mainText: {
            width: 'fit-content',
            textAlign: 'left',
            fontSize: 14,
            fontWeight: '600',
            color: theme[colorScheme].pure_black,
            fontFamily: FONT_ENUM.MAIN_BOLD,
        },
        title: {
            fontSize: 16,
            fontWeight: '500',
            fontFamily: FONT_ENUM.MAIN_BOLD,
        },
        caption: {
            fontSize: 12,
            fontWeight: '500',
            fontFamily: FONT_ENUM.MAIN_MEDIUM,
            color: theme[colorScheme].form_label,
        },
        dropdown: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'center',
            width: '100%',
            height: 'fit-content',
            padding: '4px',
            paddingLeft: 16,
            paddingRight: 16,
            marginTop: '26px',
            backgroundColor: theme[colorScheme].darkGray60,
            borderRadius: 10,
        },
        titleScreen: {
            fontSize: 15,
            fontWeight: 'bold',
            fontFamily: FONT_ENUM.REGULAR_HEADER,
            color: theme[colorScheme].form_label,
        },
        text: {
            width: 'fit-content',
            textAlign: 'left',
            fontSize: 14,
            fontWeight: 'bold',
            fontFamily: FONT_ENUM.REGULAR_HEADER,
            color: theme[colorScheme].filters_white,
            textTransform: 'capitalize',
        },
    });
